import errors from './errors';
import themes from './theme';
import features from './features';
import common from '../common';
import { CAI_MATERIAL } from '@cai/material';

export default {
  ...common,
  mobileTicket: 'Mobiilipilet',
  ...features,
  save: 'Salvesta',
  username: 'Kasutajanimi',
  password: 'Parool',
  login: 'Logi sisse',
  required: 'Nõutav',
  light: 'Valgus',
  dark: 'Tume',
  rememberMe: 'Mäleta Mind',
  eula: 'EULA',
  copyright: `© {year} - Command Alkon, Inc.`,
  termsAndConditions: 'Tingimused',
  privacyPolicy: 'Privaatsuspoliitika',
  customer: 'Klient',
  project: 'Projekt',
  isBillable: 'Arveldatav',
  dispatchDateTime: 'Kuupäev',
  orderId: 'Telli',
  ticketId: 'Pilet',
  location: 'Asukoht',
  vehicleTypeName: 'Sõiduk',
  product: 'Toode',
  products: 'Toode',
  salesTax: 'Müügimaks',
  totalPrice: 'Kokku',
  extendedPrice: 'Ext',
  destination: 'Sihtkoht',
  productId: 'Toode',
  statusCode: 'Olek',
  vehicleTypeId: 'Sõiduki tüübi ID',
  locationId: 'Asukoha ID',
  customerId: 'Kliendi ID',
  projectId: 'Projekti ID',
  dispatchTime: 'Aeg',
  showAll: 'Kuva kõik',
  hideAll: 'Peida kõik',
  undoChanges: 'Võta muudatused tagasi',
  resetColumns: 'Lähtesta veerud',
  displayRowCount: `Kuvatakse {count, plural, 
    =0 {0 rida} 
    one {# rida} 
    other {# rida} 
  }`,
  columnFilters: 'Veergude filtrid',
  visible: 'Nähtav',
  hidden: 'Peidetud',
  itemDetail: 'Üksuse üksikasjad',
  quantity: 'Kogus',
  quantityMaxWaterToAdd: `Kogus (maksimaalne lisatav vesi: {maxWaterQuantity})`,
  unloadingMethod: 'Mahalaadimise meetod',
  time: 'Aeg',
  eventStatus: 'Olek',
  MTQ_abbr: 'm\u00B3',
  EA_abbr: 'ea',
  LTR_abbr: 'L',
  YDQ_abbr: 'y³',
  GLL_abbr: 'gal',
  MTQ_text: 'Kuupmeetrit',
  M3_text: 'Kuupmeetrit',
  EA_text: 'iga',
  LTR_text: 'Liitreid',
  YDQ_text: 'Kuupmeetrid',
  GLL_text: 'Gallonid',
  ACR_text: 'Aakrid',
  HUR_text: 'Tund',
  INH_text: 'Tollid',
  FOT_text: 'Jalg',
  YRD_text: 'Õue',
  MMT_text: 'Millimeeter',
  CMT_text: 'Sentimeeter',
  MTR_text: 'Mõõdik',
  SMI_text: 'Miil (seaduslik miil)',
  KMT_text: 'Kilomeeter',
  INK_text: 'Ruuttolli',
  FTK_text: 'Ruutjalg',
  YDK_text: 'Ruuthoov',
  MIK_text: 'Ruutmiil',
  CMK_text: 'Ruutsentimeeter',
  MTK_text: 'Ruutmeeter',
  KMK_text: 'Ruutkilomeeter',
  INQ_text: 'Kuuptolli',
  MMQ_text: 'Kuupmillimeeter',
  FTQ_text: 'Kuupjalg',
  CMQ_text: 'Kuupsentimeeter',
  OZA_text: 'Vedelik unts',
  PT_text: 'Pint',
  QT_text: 'Kvart',
  MLT_text: 'Milliliter',
  ONZ_text: 'Unts',
  LBR_text: 'Nael',
  STN_text: 'Ton',
  GRM_text: 'Gram',
  KGM_text: 'Kilogramm',
  TNE_text: 'Tonn',
  PS_text: 'naela ruuttolli kohta',
  MPA_text: 'Megapaskal',
  C56_text: 'Newton ruutmillimeetri kohta',
  C62_text: 'Üks',
  NL_text: 'Laadige',
  MT_text: 'Mat',
  P1_text: 'protsenti',
  CEL_text: 'Celsiuse kraad',
  FAH_text: 'Fahrenheiti kraad',
  BLL_text: 'Tünn',
  CLT_text: 'Sentiliiter',
  DLT_text: 'Detsiliiter',
  GLI_text: 'Keiserlik gallon',
  '2U_text': 'Megagramm',
  SA_text: 'Kott',
  '60_text': 'Kaal protsentides',
  BG_text: 'Kott',
  SEC_text: 'Teiseks',
  MIN_text: 'Minut',
  '64_text': 'Nael ruuttolli kohta – mõõtur',
  SP_text: 'Riiulipakett',
  MMK_text: 'Ruutmillimeeter',
  MTN_text: 'Meetriline tonn',
  GT_text: 'Gigaton',
  '/NL_text': 'Koormuse kohta',
  '/EA_text': 'Koguse kohta',
  '/H/ + h_text': 'Tunni kohta',
  '/YQ/ + YDQ_text': 'Kuupmeetri kohta',
  '/MQ/ + MTQ_text': 'Kuupmeetri kohta',
  '/MN/ + MIN_text': 'Minuti kohta',
  '/MT_text': 'meetri kohta',
  DSG_text: 'Annustamine',
  '/C_text': '100 kaalu kohta',
  '64_2_text': 'Konkreetne',
  MTQ: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  M3: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  LTR: `{value, plural,
    =0 {0 Liitreid}
    one {1 Liiter}
    other {# Liitreid}
  }`,
  TO: `{value, plural,
    =0 {0 tonni}
    one {1 Ton}
    other {# tonni}
  }`,
  ITEM: `{value, plural,
    =0 {0 Üksused}
    one {1 Üksus}
    other {# Üksused}
  }`,
  YDQ_short: `{value, plural,
    =0 {0 y³}
    one {1 y³}
    other {# y³}
  }`,
  YDQ: `{value, plural,
    =0 {0 Kuupmeetrid}
    one {1 Kuubikuõu}
    other {# Kuupmeetrid}
  }`,
  GLL: `{value, plural,
    =0 {0 Gallonid}
    one {1 Gallon}
    other {# Gallonid}
  }`,
  EA: `{value, plural,
    =0 {0 iga}
    one {1 iga}
    other {# iga}
  }`,
  MIN: `{value, plural,
    =0 {0 Minutid}
    one {1 Minut}
    other {# Minutid}
  }`,
  ACR: `{value, plural,
    =0 {0 Aakrid}
    one {1 Acre}
    other {# Aakrid}
  }`,
  HUR: `{value, plural,
    =0 {0 Tundi}
    one {1 Tund}
    other {# Tundi}
  }`,
  INH: `{value, plural,
    =0 {0 Tollid}
    one {1 tolli}
    other {# Tollid}
  }`,
  FOT: `{value, plural,
    =0 {0 Jalad}
    one {1 Jalg}
    other {# Jalad}
  }`,
  YRD: `{value, plural,
    =0 {0 Õued}
    one {1 Õue}
    other {# Õued}
  }`,
  MMT: `{value, plural,
    =0 {0 Millimeetrid}
    one {1 Millimeeter}
    other {# Millimeetrid}
  }`,
  CMT: `{value, plural,
    =0 {0 Sentimeetrid}
    one {1 Sentimeeter}
    other {# Sentimeetrid}
  }`,
  MTR: `{value, plural,
    =0 {0 Meetrid}
    one {1 Mõõdik}
    other {# Meetrid}
  }`,
  SMI: `{value, plural,
    =0 {0 Miilid (seaduslikud miilid)}
    one {1 Miil (seaduslik miil)}
    other {# Miilid (seaduslikud miilid)}
  }`,
  KMT: `{value, plural,
    =0 {0 Kilomeetrid}
    one {1 Kilomeeter}
    other {# Kilomeetrid}
  }`,
  INK: `{value, plural,
    =0 {0 Ruuttollid}
    one {1 Ruuttolli}
    other {# Ruuttollid}
  }`,
  FTK: `{value, plural,
    =0 {0 Ruutjalga}
    one {1 Ruutjalg}
    other {# Ruutjalga}
  }`,
  YDK: `{value, plural,
    =0 {0 Square Yards}
    one {1 Ruuthoov}
    other {# Square Yards}
  }`,
  MIK: `{value, plural,
    =0 {0 Ruutmiilid}
    one {1 Ruutmiil}
    other {# Ruutmiilid}
  }`,
  CMK: `{value, plural,
    =0 {0 Ruutsentimeetrid}
    one {1 Ruutsentimeeter}
    other {# Ruutsentimeetrid}
  }`,
  MTK: `{value, plural,
    =0 {0 Ruutmeeter}
    one {1 Ruutmeeter}
    other {# Ruutmeetrid}
  }`,
  KMK: `{value, plural,
    =0 {0 Ruutkilomeetrid}
    one {1 Ruutkilomeeter}
    other {# Ruutkilomeetrid}
  }`,
  INQ: `{value, plural,
    =0 {0 Kuuptolli}
    one {1 Kuuptolli}
    other {# Kuuptolli}
  }`,
  MMQ: `{value, plural,
    =0 {0 Kuupmillimeetrit}
    one {1 Kuupmillimeeter}
    other {# Kuupmillimeetrit}
  }`,
  FTQ: `{value, plural,
    =0 {0 Kuupjalad}
    one {1 Kuupjalg}
    other {# Kuupjalad}
  }`,
  CMQ: `{value, plural,
    =0 {0 Kuupsentimeetrit}
    one {1 Kuupsentimeeter}
    other {# Kuupsentimeetrit}
  }`,
  OZA: `{value, plural,
    =0 {0 Vedelikud untsid}
    one {1 Vedelik unts}
    other {# Vedelikud untsid}
  }`,
  PT: `{value, plural,
    =0 {0 Pints}
    one {1 Pint}
    other {# Pints}
  }`,
  QT: `{value, plural,
    =0 {0 Kvartalid}
    one {1 Kvart}
    other {# Kvartalid}
  }`,
  MLT: `{value, plural,
    =0 {0 Milliliitrit}
    one {1 Milliliter}
    other {# Milliliitrit}
  }`,
  ONZ: `{value, plural,
    =0 {0 Untsi}
    one {1 Unts}
    other {# Untsi}
  }`,
  LBR: `{value, plural,
    =0 {0 Naelad}
    one {1 Nael}
    other {# Naelad}
  }`,
  STN: `{value, plural,
    =0 {0 tonni}
    one {1 Ton}
    other {# tonni}
  }`,
  GRM: `{value, plural,
    =0 {0 grammi}
    one {1 Gram}
    other {# grammi}
  }`,
  KGM: `{value, plural,
    =0 {0 Kilogrammid}
    one {1 Kilogramm}
    other {# Kilogrammid}
  }`,
  TNE: `{value, plural,
    =0 {0 tonni}
    one {1 Tonn}
    other {# tonni}
  }`,
  PS: `{value, plural,
    =0 {0 psi}
    one {1 psi}
    other {# psi}
  }`,
  MPA: `{value, plural,
    =0 {0 Megapaskalid}
    one {1 Megapaskal}
    other {# Megapaskalid}
  }`,
  C56: `{value, plural,
    =0 {0 Newtonit ruutmillimeetri kohta}
    one {1 Newton ruutmillimeetri kohta}
    other {# Newtonit ruutmillimeetri kohta}
  }`,
  C62: `{value, plural,
    =0 {0 Üks}
    one {1 Üks}
    other {# Üks}
  }`,
  NL: `{value, plural,
    =0 {0 Koormused}
    one {1 Laadige}
    other {# Koormused}
  }`,
  MT: `{value, plural,
    =0 {0 Mats}
    one {1 Mat}
    other {# Mats}
  }`,
  P1: `{value, plural,
    =0 {0 protsenti}
    one {1 protsenti}
    other {# protsenti}
  }`,
  CEL: `{value, plural,
    =0 {0 Celsiuse kraadid}
    one {1 Celsiuse kraad}
    other {# Celsiuse kraadid}
  }`,
  FAH: `{value, plural,
    =0 {0 Fahrenheiti kraadid}
    one {1 Fahrenheiti kraad}
    other {# Fahrenheiti kraadid}
  }`,
  BLL: `{value, plural,
    =0 {0 Tünnid}
    one {1 Tünn}
    other {# Tünnid}
  }`,
  CLT: `{value, plural,
    =0 {0 Sentiliitrid}
    one {1 Sentiliiter}
    other {# Sentiliitrid}
  }`,
  DLT: `{value, plural,
    =0 {0 Detsiliitrid}
    one {1 Detsiliiter}
    other {# Detsiliitrid}
  }`,
  GLI: `{value, plural,
    =0 {0 Gallonid}
    one {1 Gallon}
    other {# Gallonid}
  }`,
  '2U': `{value, plural,
    =0 {0 Megagrammid}
    one {1 Megagramm}
    other {# Megagrammid}
  }`,
  SA: `{value, plural,
    =0 {0 Kotid}
    one {1 Kott}
    other {# Kotid}
  }`,
  60: `{value, plural,
    =0 {0 Kaal protsentides}
    one {1 Kaal protsentides}
    other {# Kaal protsentides}
  }`,
  BG: `{value, plural,
    =0 {0 Kotid}
    one {1 Kott}
    other {# Kotid}
  }`,
  SEC: `{value, plural,
    =0 {0 Sekundid}
    one {1 Teiseks}
    other {# Sekundid}
  }`,
  64: `{value, plural,
    =0 {0 Naela ruuttolli kohta – mõõtur}
    one {1 Nael ruuttolli kohta – mõõtur}
    other {# Naela ruuttolli kohta – mõõtur}
  }`,
  SP: `{value, plural,
    =0 {0 Riiulipaketid}
    one {1 Riiulipakett}
    other {# Riiulipaketid}
  }`,
  MMK: `{value, plural,
    =0 {0 Ruutmillimeetrid}
    one {1 Ruutmillimeeter}
    other {# Ruutmillimeetrid}
  }`,
  MTN: `{value, plural,
    =0 {0 Meetrilist tonni}
    one {1 Meetriline tonn}
    other {# Meetrilist tonni}
  }`,
  GT: `{value, plural,
    =0 {0 Gigatonid}
    one {1 Gigaton}
    other {# Gigatonid}
  }`,
  '/NL': `{value, plural,
    =0 {0 Koormuse kohta}
    one {1 Koormuse kohta}
    other {# Koormuse kohta}
  }`,
  '/EA': `{value, plural,
    =0 {0 Koguse kohta}
    one {1 Koguse kohta}
    other {# Koguse kohta}
  }`,
  '/H/ + h': `{value, plural,
    =0 {0 Tunni kohta}
    one {1 Tunni kohta}
    other {# Tunni kohta}
  }`,
  '/YQ/ + YDQ': `{value, plural,
    =0 {0 Kuupmeetri kohta}
    one {1 Kuupmeetri kohta}
    other {# Kuupmeetri kohta}
  }`,
  '/MQ/ + MTQ': `{value, plural,
    =0 {0 Kuupmeetri kohta}
    one {1 Kuupmeetri kohta}
    other {# Kuupmeetri kohta}
  }`,
  '/MN/ + MIN': `{value, plural,
    =0 {0 Minuti kohta}
    one {1 Minuti kohta}
    other {# Minuti kohta}
  }`,
  '/MT': `{value, plural,
    =0 {0 meetri kohta}
    one {1 meetri kohta}
    other {# meetri kohta}
  }`,
  DSG: `{value, plural,
    =0 {0 Annustamine}
    one {1 Annustamine}
    other {# Annustamine}
  }`,
  '/C': `{value, plural,
    =0 {0 100 kaalu kohta}
    one {1 100 kaalu kohta}
    other {# 100 kaalu kohta}
  }`,
  '64_2': `{value, plural,
    =0 {0 Konkreetne}
    one {1 Konkreetne}
    other {# Konkreetne}
  }`,
  LTR_short: `{value, plural,
  =0 {0 L}
  one {1 L}
  other {# L}
  }`,
  TO_short: `{value, plural,
  =0 {0 tonni}
  one {1 tonni}
  other {# tonni}
}`,
  ITEM_short: `{value, plural,
  =0 {0 Üksused}
  one {1 Üksus}
  other {# Üksused}
}`,
  GLL_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  EA_short: `{value, plural,
  =0 {0 ea}
  one {1 ea}
  other {# ea}
}`,
  MIN_short: `{value, plural,
  =0 {0 min}
  one {1 min}
  other {# min}
}`,
  ACR_short: `{value, plural,
  =0 {0 ac}
  one {1 ac}
  other {# ac}
}`,
  HUR_short: `{value, plural,
  =0 {0 hr}
  one {1 hr}
  other {# hr}
}`,
  INH_short: `{value, plural,
  =0 {0 in}
  one {1 in}
  other {# in}
}`,
  FOT_short: `{value, plural,
  =0 {0 ft}
  one {1 ft}
  other {# ft}
}`,
  YRD_short: `{value, plural,
  =0 {0 yd}
  one {1 yd}
  other {# yd}
}`,
  MMT_short: `{value, plural,
  =0 {0 mm}
  one {1 mm}
  other {# mm}
}`,
  CMT_short: `{value, plural,
  =0 {0 cm}
  one {1 cm}
  other {# cm }
}`,
  MTR_short: `{value, plural,
  =0 {0 m}
  one {1 m}
  other {# m}
}`,
  SMI_short: `{value, plural,
  =0 {0 Miilid (st mi)}
  one {1 Miil ((st mi)}
  other {# Miilid ((st mi)}
}`,
  KMT_short: `{value, plural,
  =0 {0 km}
  one {1 km}
  other {# km}
}`,
  INK_short: `{value, plural,
  =0 {0 in²}
  one {1 in²}
  other {# in²}
}`,
  FTK_short: `{value, plural,
  =0 {0 ft²}
  one {1 ft²}
  other {# ft²}
}`,
  YDK_short: `{value, plural,
  =0 {0 yd²}
  one {1 yd²}
  other {# yd²}
}`,
  MIK_short: `{value, plural,
  =0 {0 mi²}
  one {1 mi²}
  other {# mi²}
}`,
  CMK_short: `{value, plural,
  =0 {0 cm²}
  one {1 cm²}
  other {# cm²}
}`,
  MTK_short: `{value, plural,
  =0 {0 m²}
  one {1 m²}
  other {# m²}
}`,
  KMK_short: `{value, plural,
  =0 {0 km²}
  one {1 km²}
  other {# km²}
}`,
  INQ_short: `{value, plural,
  =0 {0 in³}
  one {1 in³}
  other {# in³}
}`,
  MMQ_short: `{value, plural,
  =0 {0 mm³}
  one {1 mm³}
  other {# mm³}
}`,
  FTQ_short: `{value, plural,
  =0 {0 ft³}
  one {1 ft³}
  other {# ft³}
}`,
  CMQ_short: `{value, plural,
  =0 {0 cm³}
  one {1 cm³}
  other {# cm³}
}`,
  OZA_short: `{value, plural,
  =0 {0 fl oz}
  one {1 fl oz}
  other {# fl oz}
}`,
  PT_short: `{value, plural,
  =0 {0 pt}
  one {1 pt}
  other {# pt}
}`,
  QT_short: `{value, plural,
  =0 {0 qt}
  one {1 qt}
  other {# qt}
}`,
  MLT_short: `{value, plural,
  =0 {0 mL}
  one {1 mL}
  other {# mL}
}`,
  ONZ_short: `{value, plural,
  =0 {0 oz}
  one {1 oz}
  other {# oz}
}`,
  LBR_short: `{value, plural,
  =0 {0 lb}
  one {1 lb}
  other {# lb}
}`,
  STN_short: `{value, plural,
  =0 {0 tonni}
  one {1 tonni}
  other {# tonni}
}`,
  GRM_short: `{value, plural,
  =0 {0 g}
  one {1 g}
  other {# g}
}`,
  KGM_short: `{value, plural,
  =0 {0 kg}
  one {1 kg}
  other {# kg}
}`,
  TNE_short: `{value, plural,
  =0 {0 t}
  one {1 t}
  other {# t}
}`,
  PS_short: `{value, plural,
  =0 {0 psi}
  one {1 psi}
  other {# psi}
}`,
  MPA_short: `{value, plural,
  =0 {0 mpa}
  one {1 mpa}
  other {# mpa}
}`,
  C56_short: `{value, plural,
  =0 {0 Newtonit ruutmillimeetri kohta}
  one {1 Newton ruutmillimeetri kohta}
  other {# Newtonit ruutmillimeetri kohta}
}`,
  C62_short: `{value, plural,
  =0 {0 Üks}
  one {1 Üks}
  other {# Üks}
}`,
  NL_short: `{value, plural,
  =0 {0 Koormused}
  one {1 Laadige}
  other {# Koormused}
}`,
  MT_short: `{value, plural,
  =0 {0 Mats}
  one {1 Mat}
  other {# Mats}
}`,
  P1_short: `{value, plural,
  =0 {0 %}
  one {1 %}
  other {# %}
}`,
  CEL_short: `{value, plural,
  =0 {0 c}
  one {1 c}
  other {# c}
}`,
  FAH_short: `{value, plural,
  =0 {0 f}
  one {1 f}
  other {# f}
}`,
  BLL_short: `{value, plural,
  =0 {0 bbl}
  one {1 bbl}
  other {# bbl}
}`,
  CLT_short: `{value, plural,
  =0 {0 cL}
  one {1 cL}
  other {# cL}
}`,
  DLT_short: `{value, plural,
  =0 {0 dL}
  one {1 dL}
  other {# dL}
}`,
  GLI_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  '2U_short': `{value, plural,
  =0 {0 Megagrammid}
  one {1 Megagramm}
  other {# Megagrammid}
}`,
  SA_short: `{value, plural,
  =0 {0 Kotid}
  one {1 Kott}
  other {# Kotid}
}`,
  '60_short': `{value, plural,
  =0 {0 % kaal}
  one {1 % kaal}
  other {# % kaal}
}`,
  BG_short: `{value, plural,
  =0 {0 Kotid}
  one {1 Kott}
  other {# Kotid}
}`,
  SEC_short: `{value, plural,
  =0 {0 sek}
  one {1 sek}
  other {# sek}
}`,
  '64_short': `{value, plural,
  =0 {0 Naela ruuttolli kohta – mõõtur}
  one {1 Nael ruuttolli kohta – mõõtur}
  other {# Naela ruuttolli kohta – mõõtur}
}`,
  SP_short: `{value, plural,
  =0 {0 Riiulipaketid}
  one {1 Riiulipakett}
  other {# Riiulipaketid}
}`,
  MMK_short: `{value, plural,
  =0 {0 Ruutmillimeetrid}
  one {1 Ruutmillimeeter}
  other {# Ruutmillimeetrid}
}`,
  MTN_short: `{value, plural,
  =0 {0 mt}
  one {1 mt}
  other {# mt}
}`,
  GT_short: `{value, plural,
  =0 {0 gt}
  one {1 gt}
  other {# gt}
}`,
  '/NL_short': `{value, plural,
  =0 {0 /Load}
  one {1 /Load}
  other {# /Load}
}`,
  '/EA_short': `{value, plural,
  =0 {0 /ea}
  one {1 /ea}
  other {# /ea}
}`,
  '/H/ + h_short': `{value, plural,
  =0 {0 /Hour}
  one {1 /Hour}
  other {# /Hour}
}`,
  '/YQ/ + YDQ_short': `{value, plural,
  =0 {0 /y³}
  one {1 /y³}
  other {# /y³}
}`,
  '/MQ/ + MTQ_short': `{value, plural,
  =0 {0 /m³}
  one {1 /m³}
  other {# /m³}
}`,
  '/MN/ + MIN_short': `{value, plural,
  =0 {0 /min}
  one {1 /min}
  other {# /min}
}`,
  '/MT_short': `{value, plural,
  =0 {0 /m}
  one {1 /m}
  other {# /m}
}`,
  DSG_short: `{value, plural,
  =0 {0 Annustamine}
  one {1 Annustamine}
  other {# Annustamine}
}`,
  '/C_short': `{value, plural,
  =0 {0 /c}
  one {1 /c}
  other {# /c}
}`,
  '64_2_short': `{value, plural,
  =0 {0 Konkreetne}
  one {1 Konkreetne}
  other {# Konkreetne}
}`,
  mixIdLabel: 'Sega ID/kirjeldus',
  productIdLabel: 'Toote ID/kirjeldus',
  orderedQtyLabel: 'Tellitud kogus',
  loadedQtyLabel: 'Laaditud kogus',
  addedByCustomer: 'Kliendi lisatud',
  PRINTED: 'Piletiga',
  LOADING_STARTED: 'Alusta laadimist',
  LOADING_COMPLETE: 'Lõpeta laadimine',
  TO_JOB: 'Vasak taim',
  ARRIVE_JOB: 'Saabumiskoht',
  UNLOADING: 'Alusta mahalaadimist',
  END_UNLOADING: 'Lõpeta mahalaadimine',
  LEAVE_JOB: 'Lahku töökohast',
  IN_YARD: 'Õues',
  WASHING: 'Pesemine',
  END_WASHING: 'Pesemise lõpp',
  PUMPING_STARTED: 'Käivitage pump',
  PUMPING_COMPLETE: 'Lõpeta pump',
  READY_TO_PUMP: 'Pumpamiseks valmis',
  FIRST_WCCONTACT: 'Esimene veetsemendi kontakt',
  plantName: 'Taime nimi',
  plantAddress: 'Taime aadress',
  loadingScheduleStart: 'Plaanitud laadimisaeg',
  deliveryAddress: 'Tarneaadress',
  phoneNumber: 'Telefoninumber',
  unloadingScheduleStart: 'Planeeritud mahalaadimisaeg (ETA)',
  agreedUnloading: 'Tellitud mahalaadimisajad',
  deliveryInformation: 'Kohaletoimetamise teave',
  next: 'Edasi',
  material: 'Materjal',
  loadingPoint: 'Laadimispunkt',
  unloadingPoint: 'Mahalaadimispunkt',
  getDirections: 'Hankige juhised',
  comment: 'kommenteerida',
  sapDeliveryNumber: 'SAP tarnenumber (BCC number)',
  salesOrderNumber: 'Müügitellimuse number ja kauba rida',
  wcDateTime: 'Kuupäev ja kellaaeg W/C kontakt',
  po: 'PO number',
  orderedByName: 'Tellimus tehtud nime järgi',
  orderedByPhone: 'Tellimus tehtud telefoninumbril',
  resourceId: 'Ressursi ID',
  totalLoadedQty: 'Laaditud kogus koos selle koormaga',
  spacing: 'Laadimisruum',
  deliveryFlow: 'Tarnevoog',
  timeOnSite: 'Kokku kohapeal viibitud aeg/tellitud mahalaadimisaeg',
  salesText: 'Müügi tekst (materjali ID)',
  strengthClass: 'Jõuklass',
  environmentExposure: 'Kokkupuude keskkonnaga',
  metExposureClasses: 'Kokkupuuteklassid',
  dmax: 'Dmax',
  standardCert: 'Standard (sertifikaat)',
  workabilityTarget: 'Kliendi töövõime eesmärk',
  stoneQuality: 'Kivi kvaliteet',
  sandQuality: 'Liiva kvaliteet',
  targetWC: 'Retsepti järgi seatud W/C suhe',
  controlClass: 'Kontrollklass',
  chlorideClass: 'Kloriidi klass',
  typeAndStrength1: 'Tsemendi tüüp ja tugevusklass 1',
  typeAndStrength2: 'Tsemendi tüüp ja tugevusklass 2',
  typeOfAddition: 'Lisamise tüüp',
  typeOfAdmixture: 'Segu tüüp',
  orderedTemp: 'Tellitud temperatuur',
  fibers1: 'Kiudude tüüp ja sisaldus 1',
  fibers2: 'Kiudude tüüp ja sisaldus 2',
  calculatedMaturityTime: 'Arvutatud valmimisaeg W/C kontaktiajast',
  mixIdentity: 'Sega identiteet',
  grade: 'Hinne',
  mixType: 'Sega tüüp',
  maxAggSize: 'Max Agg suurus',
  maxAggType: 'Max Agg tüüp',
  cementType: 'Tsemendi tüüp',
  admixtures: 'Lisandid',
  addmixDescription: 'Admixi kirjeldus',
  slump: 'Madal',
  minCementContent: 'Minimaalne tsemendisisaldus',
  maxWatCemRatio: 'Maksimaalne vee/tsemendi suhe',
  maxWaterToAdd: 'Maksimaalne lisatav vesi',
  mortarMinWorkingLife: 'Mördi minimaalne tööiga',
  code: 'Kood',
  dcClass: 'dcClass',
  chloride: 'kloriid',
  signedByHanson: 'Allkirjastanud Hanson',
  warmStamp: 'Soe tempel',
  coldStamp: 'Külmtempel',
  containsSikatard: 'Sisaldab Sikatari',
  containsDelvo: 'Sisaldab Delvot',
  generalDelivery: 'Üldine kohaletoimetamise teave',
  materialInfo: 'Materjali teave',
  water: 'Vesi',
  materialService: 'Materjal / Teenus',
  returnedMaterial: 'Tagastatud materjal',
  returnedConcrete: 'Tagastatud betoon',
  waterAdded: 'Lisatud vesi',
  concreteOnTruck: 'Betoon veoautol',
  concreteOnTruckUom: 'Veoauto UOM-i vaikebetoon',
  reason: 'Põhjus',
  customerAddedWater: 'Klient lisas vett',
  addWater: 'Lisa vesi',
  addedAt: 'Lisatud kell',
  addMaterialService: 'Lisage materjal/teenus',
  customerAddedProduct: 'Klient lisas toote',
  addReturnedMaterial: 'Lisage tagastatud materjal',
  leftover: 'Ülejäänud',
  submitAcceptance: 'Esitage nõustumine',
  accepted: 'Vastu võetud',
  rejected: 'Tagasi lükatud',
  customerAcceptance: 'Vastuvõtmine',
  finalize: 'Lõpeta',
  earlyAcceptance: 'Varajane vastuvõtt',
  materialSummary: 'Materjali kokkuvõte',
  mix: 'Sega',
  ordered: 'Tellitud',
  loaded: 'Tarnekoormus',
  totalOrdered: 'Tellimuse koguhulk',
  loadedOrderQuantity: 'Laaditud tellimuse kogus',
  loadedOrder: 'Laaditud tellimus',
  driverComment: 'Juhi kommentaar',
  driverCommentInternal: 'Juhi kommentaar (sisemine)',
  customerComment: 'Kliendi kommentaar',
  editComment: 'Muuda kommentaari',
  addComment: 'Lisa kommentaar',
  additionalInfo: 'Lisainfo',
  onBoard: 'Pardal',
  driver: 'Juht',
  commentInstruction: 'Kommentaari juhis',
  signatureInstruction: 'Kliendi allkiri*',
  customerSignature: 'Kliendi allkiri',
  general: 'Kindral',
  status: 'Olek',
  updateStatusTime: 'Värskenda oleku aega',
  delete: 'Kustuta',
  cancel: 'Tühista',
  back: 'Tagasi',
  add: 'Lisa',
  edit: 'Muuda',
  done: 'Valmis',
  ok: 'OK',
  decline: 'Keeldumine',
  Submit: 'Esita',
  submit: 'Esita',
  lastRefresh: 'Viimane värskendus',
  refreshEnabled: 'Luba Värskendus',
  id: 'ID',
  name: 'Nimi',
  invoiceable: 'Arveldatav',
  provideSignature: 'Andke allkiri',
  ticket: 'Pilet',
  details: 'Üksikasjad',
  qrCode: 'QR-kood',
  driverAcceptanceReason: 'Põhjus',
  driverAcceptance: 'Juhi aktsepteerimine',
  'payment-method': 'Makseviisid',
  'add-payment-method': 'Lisa makseviis',
  'reason-code': 'Põhjuse kood',
  'add-reason-code': 'Lisa põhjuse kood',
  'qr-code': 'QR-kood',
  'unloading-method': 'Mahalaadimismeetodid',
  'add-unloading-method': 'Lisa mahalaadimismeetod',
  'driver-comment': 'Juhi kommentaarid',
  'add-driver-comment': 'Lisa juhi kommentaar',
  'driver-sellable': 'Juht müüa',
  vehicle: 'Sõidukid',
  'add-vehicle': 'Lisa sõiduk',
  'vehicle-type': 'Sõidukite tüübid',
  vehicleTypes: 'Sõidukite tüübid',
  vehicleType: 'Sõiduki tüüp',
  'add-vehicle-type': 'Lisage sõiduki tüüp',
  countries: 'Riigid',
  country: 'Riik',
  type: 'Tüüp',
  uom: 'UOM',
  mandatory: 'Kohustuslik',
  qrTemplate: 'QR-koodi mall',
  includeMixInfo: 'Lisage QR-koodi seguteave',
  includeTicketEvents: 'Lisage piletiüritused QR-koodi',
  quantityField: 'Luba koguseväli',
  concreteOnTruckField: 'Luba Betoon veoautoväljal',
  materialOnTruckField: 'Luba materjali veoauto põllul',
  timeField: 'Luba ajaväli',
  reasonField: 'Luba põhjusväli',
  driverInstructions: 'Juhised juhile',
  waitingForTicket: 'Ootan piletit...',
  createTestTicketForTruck: 'Looge veokile testipilet',
  exceedsLoadedQuantity: `Väärtus ei tohi ületada laaditud kogust {loadedQuantity}.`,
  maxQuantity: 'Maksimaalne kogus',
  maxQuantityError: `Kogus ei tohi ületada määratletud maksimaalset kogust {maxQty}`,
  maxValueError: `Väärtus ei tohi ületada määratletud maksimumi {maxQty}`,
  minValueError: `Väärtus ei saa olla väiksem kui määratletud miinimum {minQty}`,
  notAuthorized: 'Pole volitatud',
  enterTruckNumber: 'Sisestage veoauto number',
  setTruckNumber: 'Veoauto numbri määramine',
  commentList: 'Kommentaaride loend',
  list: 'Nimekiri',
  gridPreferences: 'Võrgueelistused',
  loadingUnloadingPoints: 'Laadimis-/mahalaadimispunktid',
  activity: 'Tegevus',
  crn: 'Crn',
  update: 'Värskenda',
  CONCRETE: 'Betoonist',
  WATER: 'Vesi',
  ADDITIVE: 'Lisand',
  'submit-signature-button': 'Nõustu',
  'cancel-signature-button': 'Tühista',
  uomCode: 'Vaikimisi UOM',
  'product-type': 'Tootetüübid',
  'add-product-type': 'Lisa toote tüüp',
  'add-product': 'Lisa toode',
  'setup_driver-comment': 'Juhi kommentaarid',
  setup_product: 'Tooted',
  'setup_product-type': 'Tootetüübid',
  'setup_qr-code': 'QR-kood',
  'setup_reason-code': 'Põhjuskoodid',
  'setup_unloading-method': 'Mahalaadimismeetodid',
  'setup_entity-mt': 'Ettevõte',
  setup_vehicle: 'Sõidukid',
  'setup_vehicle-type': 'Sõidukite tüübid',
  'setup_data-retentions': 'Andmete säilitamine',
  'add-data-retentions': 'Andmete säilitamise lisamine',
  'data-retentions': 'Andmete säilitamine',
  setup_carriers: 'Kandjad',
  'add-carriers': 'Lisage kandjad',
  carriers: 'Kandjad',
  'setup_concrete-classes': 'Materjali vastavus',
  'add-concrete-classes': 'Lisage materjali vastavus',
  'concrete-classes': 'Materjali vastavus',
  'setup_forms-and-waivers': 'Vormid ja loobumised',
  'add-forms-and-waivers': 'Lisage vormid ja loobumised',
  'forms-and-waivers': 'Vormid ja loobumised',
  companyFleet: 'Ettevõtte laevastik',
  category: 'Kategooria',
  interval: 'Intervall',
  orders: 'Tellimused Ja piletid',
  '30days': '30 päeva',
  '60days': '60 päeva',
  '90days': '90 päeva',
  '1year': '1 aasta',
  '3years': '3 aastat',
  waterMandatory: 'Vesi Kohustuslik',
  qrCodeTemplate: 'QR-koodi mall',
  waterConfig: 'Valikulised väljad',
  waterProduct: 'Vesi',
  waterProductType: 'Veetoote tüüp',
  defaultWaterProduct: 'Vaikimisi veetoode',
  invalidTemplate: 'Kehtetu mall',
  siteAddress: 'Saidi aadress',
  siteContactName: 'Saidi kontaktisiku nimi',
  siteContactPhoneNumber: 'Saidi kontakttelefon',
  'clear-signature-button': 'Selge allkiri',
  customerCommentEnabled: 'Luba kliendi kommentaar',
  driverCommentEnabled: 'Luba draiveri kommentaar',
  driverCommentMaxCharacters: 'Max pikkus',
  customerCommentMaxCharacters: 'Max pikkus',
  timeZone: 'Ajavöönd',
  driverDidNotAdd: 'Juht ei lisanud',
  noWaterAdded: 'Vett pole lisatud',
  maxLineItems: 'Maksimaalne reaüksuste arv',
  oneLineItem: 'Peab olema vähemalt 1 reaüksus',
  signatureSiteContact: 'Kliendi nimi',
  signatureSiteContactMandatory: 'Kliendi nimi *',
  ticketEvents: 'Piletiüritused',
  hideEvent: 'Peida sündmus',
  editable: 'Redigeeritav',
  ticketDetail: `Pilet #{value}`,
  statusTimes: 'Olekuajad',
  materialAndDeliveryInfo: 'Materjali ja tarneteave',
  customerRejection: 'Kliendi tagasilükkamine',
  'submit-rejection-button': 'Esita tagasilükkamine',
  accept: 'Nõustu',
  reject: 'Keeldu laadimisest',
  signature: 'Allkiri',
  'no-signature': 'Allkirja puudub',
  unFinalizePassword: 'Tühista parooli lõpuleviimine',
  waterInWorkflow: 'Lubage töövoos Water Step',
  multicountry: 'Mitu riiki',
  timestampAfterSequence: 'HOIATUS. Aeg ei tohi olla enne eelmist ajatemplit',
  timestampBeforeSequence: 'HOIATUS. Aeg ei tohiks olla hilisem kui järgmine ajatempel',
  noRestQuantity: 'Tagastatavat materjali pole',
  returnedMaterialMandatory: 'Peab suhtlema tagastatud materjali etapiga',
  driverCommentMaxChars: `Pikkus ei tohi ületada {maxLength} tähemärki.`,
  QrCodeEnabled: 'Luba QR-kood',
  QrMethod_linkBased: 'Lingipõhine',
  QrMethod_contentBased: 'Sisupõhine, MÄRKUS. Sisupõhistel QR-koodidel on tähemärgipiirangud, mis võivad põhjustada probleeme, mis on pikemad kui 1024 tähemärki.',
  QrMethod_contentBasedWarning: `MÄRKUS. Selles QR-koodis on {amount} tähemärki, mida mõned telefonid ei pruugi lugeda.`,
  returnedMaterialInWorkflow: 'Tagastatud materjali etapi lubamine töövoos',
  materialServiceInWorkflow: 'Luba töövoos materjali/teenuse etapp',
  totalPumpedQuantity: 'Kogu pumbatav kogus',
  concrete: 'Betoonist',
  materialComplianceEnabled: 'Luba materjali vastavus',
  pumpStatusTimes: 'Pumba oleku ajad',
  pollingInterval: 'Küsitluse intervall (sekundites)',
  tenSecs: 'Intervall peab olema vähemalt 10 sekundit',
  materialCompliance: 'Materjali vastavus',
  materialCompliance_notFound: 'Materjali vastavust ei leitud',
  materialCompliance_outOfRange_warning: 'Sisestatud väärtus on väljaspool betooniklassi lubatud vahemikku.',
  consistenceValue: 'Järjepidevus – madalseis',
  consistenceIsCompliant: 'Järjepidevus vastab standardile BS8500-2',
  airContentValue: 'Õhusisaldus',
  airContentIsCompliant: 'Õhusisu vastab standardile BS8500-2',
  consistenceIsCompliantShort: 'Järjepidevus vastab',
  airContentIsCompliantShort: 'Air Content vastab nõuetele',
  compliance: 'Materjali vastavus standardile BS8500-2',
  termsAndConditionsEnabled: 'Luba tingimuste vorm',
  damageWaiverEnabled: 'Luba kahjust loobumise vorm',
  damageWaiver: 'Kahju hüvitamisest loobumine',
  damageWaiverAcknowledged: 'Kahju hüvitamisest loobumist tunnustati',
  dynamicWaiver: 'Dünaamiline loobumine',
  dynamicWaiverEnabled: 'Luba dünaamilise loobumise vorm',
  ticketListEnabled: 'Luba piletiloend',
  clearTicketAfterSubmission: 'Tühjenda pilet pärast esitamist',
  keepTicketOpenAfterSubmission: 'Hoidke pilet pärast esitamist avatuna',
  displayTicketList: 'Kuva piletite nimekiri',
  supportedLanguages: 'Toetatud keeled',
  allow: 'Luba',
  default: 'Vaikimisi',
  isCertificationLossTriggerForReason: 'Märkus sertifikaadi kaotamise põhjus',
  isCertificationLossTriggerForProduct: 'Sertifikaadi kaotamise märkus toode',
  translations: 'Tõlked',
  family_name: 'Perekonnanimi',
  given_name: 'Eesnimi',
  email: 'Meil',
  role: 'Roll',
  inviteUser: 'Kutsu kasutaja',
  carrier: 'Kandja',
  emailOrPhoneNumber: 'Meil',
  usersEditor: 'Kasutaja redaktor',
  verifyPassword: 'Kinnitage parool',
  verificationCode: 'Kinnituskood',
  register: 'Registreeru',
  registerInstructions: 'Registreerimise lõpetamiseks täitke see vorm.',
  'password-requirements': 'Teie parool peab koosnema vähemalt 8 tähemärgist, sisaldama vähemalt 1 suurtähte, 1 väiketähte, 1 numbrit ja 1 erimärki.',
  passwordMinCharacters: 'Parool peab sisaldama 8 või enam tähemärki.',
  passwordMaxCharacters: 'Parool ei tohi sisaldada üle 99 tähemärgi.',
  passwordLowerCase: 'Parool peab sisaldama ühte või enamat väiketähte.',
  passwordUpperCase: 'Parool peab sisaldama ühte või enamat suurtähte.',
  passwordNumber: 'Parool peab sisaldama ühte või enamat numbrit.',
  passwordSpecialCharacter: 'Parool peab sisaldama ühte või enamat erimärki.',
  passwordsDontMatch: 'Paroolid ei ühti!',
  success: 'Edu!',
  'registration-success': 'Teie registreerimine õnnestus.',
  'post-registration-instructions': 'Olete registreerimisprotsessi lõpetanud. Nüüd saate sisse logida.',
  createDate: 'Loo kuupäev',
  customerPo: 'Kliendi ostutellimuse number',
  specification: 'Spetsifikatsioon',
  description: 'Kirjeldus',
  classType: 'Klassi tüüp',
  minimumValue: 'Minimaalne väärtus',
  maximumValue: 'Maksimaalne väärtus',
  TrackIt: 'TrackIt',
  trackIt3PContext: 'TrackIt 3P kontekst',
  inviteLanguage: 'Kutsu keel',
  truckNumber: 'Veoauto number',
  adverseTemperature: 'Segamise ajal oli ümbritseva õhu temperatuur selline, et me ei saa garanteerida, et betooni temperatuurivahemik on 5-35 °C, nagu on ette nähtud EN 206.',
  environmentalNote: 'See koormus sisaldab keskkonnamõjurit, mis ei ületa 0,03% betooni massist. Seda materjali sisaldav vesi betooni valmistamiseks vastab standardile BS EN 1008.',
  unloadingMethodEnabled: 'Luba mahalaadimismeetod',
  warrantyVoided: 'Materjali garantii kehtetu',
  materialWarrantyVoidedEnabled: 'Kui kasutatakse toote või toote ja põhjuse koodi, näidake allkirjastamisel sertifikaadi kadumise teadet.',
  'setup_templates-mt': 'Mallid',
  copyFrom: 'Kopeeri asukohast...',
  copy: 'kopeerida',
  users: 'Kasutajad',
  setup: 'Seadistamine',
  driverExperience: 'Juhi kogemus',
  ticketList: 'Piletite nimekiri',
  content: 'Sisu',
  WARNINGS: 'Hoiatused',
  TERMS: 'Tingimused',
  DAMAGE: 'Kahju',
  ADDITIONALWAIVER: 'Täiendav loobumine',
  DYNAMICWAIVER: 'Dünaamiline loobumine',
  source: 'Allikas',
  sensorUnable: 'Andur ei suuda järelejäänud kogust määrata.',
  PROBE: 'Sond',
  DRIVER: 'Juht',
  DRS: 'DRS',
  waterReleaseFormEnabled: 'Luba vee vabastamise vorm',
  waterRelease: 'Vee vabastamine',
  waterReleaseMandatory: 'Vee vabanemine *',
  waterReleaseAcknowledged: 'Vee vabanemine on kinnitatud',
  'assessment-risk': 'Riski hindamine',
  'setup_assessment-risk': 'Riski hindamine',
  'add-assessment-risk': 'Lisage riskianalüüs',
  enterRecipientsButton: 'Sisesta adressaat(id)',
  recipientsInstructions: 'Sisestage komaga eraldatud e-post',
  enter: 'Sisestage',
  invalidEmailAddress: 'vale meiliaadress',
  personalDataPolicy: 'Sellele vormile isikuandmeid sisestades kinnitate, et teil on nende isikuandmete jagamiseks vajalikud load',
  subcategory: 'Alamkategooria',
  isRequired: 'On nõutav',
  riskAssessmentEnabled: 'Luba riskianalüüs',
  riskAssessment: 'Riski hindamine',
  yes: 'Jah',
  no: 'Ei',
  sourceOptionsSensors: 'Allika valikud (andurid)',
  sourceDcm: 'DCM',
  sourceProbe: 'Sond',
  availableCustomValues: 'Saadaolevad kohandatud väärtused',
  ERR_CODE__DUPLICATE: 'Duplikaat',
  ERR_CODE__DEFAULT_VALUE: 'Vaikeväärtus on juba olemas',
  ERR_CODE__EXISTING_FORM: 'Selle sõiduki ja tüübi jaoks on juba aktiivne vorm',
  availableValues: 'Saadaolevad väärtused',
  pump: 'Pump',
  DanskName: 'Danski nimi',
  GermanName: 'Saksa nimi',
  EnglishName: 'Ingliskeelne nimi',
  BritainName: 'Suurbritannia nimi',
  SpanishName: 'Hispaania nimi',
  FrenchName: 'Prantsuse nimi',
  NederlandsName: 'Hollandi nimi',
  NorskName: 'Norsk nimi',
  SvenskaName: 'Svenska nimi',
  ItalianName: 'Itaalia nimi',
  PolishName: 'Poola nimi',
  DanskNameDefault: 'Danski nimi (vaikimisi)',
  GermanNameDefault: 'Saksa nimi (vaikimisi)',
  EnglishNameDefault: 'Ingliskeelne nimi (vaikimisi)',
  BritainNameDefault: 'Suurbritannia nimi (vaikimisi)',
  SpanishNameDefault: 'Hispaania nimi (vaikimisi)',
  FrenchNameDefault: 'Prantsuse nimi (vaikimisi)',
  NederlandsNameDefault: 'Hollandi nimi (vaikimisi)',
  NorskNameDefault: 'Norsk nimi (vaikimisi)',
  SvenskaNameDefault: 'Svenska nimi (vaikimisi)',
  ItalianNameDefault: 'Itaalia nimi (vaikimisi)',
  PolishNameDefault: 'Poola nimi (vaikimisi)',
  DanskDescription: 'Dansk Kirjeldus',
  GermanDescription: 'Saksakeelne kirjeldus',
  EnglishDescription: 'Ingliskeelne kirjeldus',
  BritainDescription: 'Suurbritannia Kirjeldus',
  SpanishDescription: 'Hispaania kirjeldus',
  FrenchDescription: 'Prantsuse kirjeldus',
  NederlandsDescription: 'Nederlands Kirjeldus',
  NorskDescription: 'Norsk Kirjeldus',
  SvenskaDescription: 'Svenska Kirjeldus',
  ItalianDescription: 'Itaalia kirjeldus',
  PolishDescription: 'Poola kirjeldus',
  DanskDescriptionDefault: 'Danski kirjeldus (vaikimisi)',
  GermanDescriptionDefault: 'Saksakeelne kirjeldus (vaikimisi)',
  EnglishDescriptionDefault: 'Ingliskeelne kirjeldus (vaikimisi)',
  BritainDescriptionDefault: 'Suurbritannia kirjeldus (vaikimisi)',
  SpanishDescriptionDefault: 'Hispaania kirjeldus (vaikimisi)',
  FrenchDescriptionDefault: 'Prantsuse kirjeldus (vaikimisi)',
  NederlandsDescriptionDefault: 'Nederlandsi kirjeldus (vaikimisi)',
  NorskDescriptionDefault: 'Norski kirjeldus (vaikimisi)',
  SvenskaDescriptionDefault: 'Svenska kirjeldus (vaikimisi)',
  ItalianDescriptionDefault: 'Itaalia kirjeldus (vaikimisi)',
  PolishDescriptionDefault: 'Poolakeelne kirjeldus (vaikimisi)',
  DanskContent: 'Danski sisu',
  GermanContent: 'Saksa sisu',
  EnglishContent: 'Ingliskeelne sisu',
  BritainContent: 'Suurbritannia sisu',
  SpanishContent: 'Hispaania sisu',
  FrenchContent: 'Prantsuse sisu',
  NederlandsContent: 'Hollandi sisu',
  NorskContent: 'Norsk sisu',
  SvenskaContent: 'Svenska sisu',
  ItalianContent: 'Itaalia sisu',
  PolishContent: 'Poola sisu',
  DanskContentDefault: 'Danski sisu (vaikimisi)',
  GermanContentDefault: 'Saksakeelne sisu (vaikimisi)',
  EnglishContentDefault: 'Ingliskeelne sisu (vaikimisi)',
  BritainContentDefault: 'Suurbritannia sisu (vaikimisi)',
  SpanishContentDefault: 'Hispaania sisu (vaikimisi)',
  FrenchContentDefault: 'Prantsuse sisu (vaikimisi)',
  NederlandsContentDefault: 'Nederlandsi sisu (vaikimisi)',
  NorskContentDefault: 'Norsk sisu (vaikimisi)',
  SvenskaContentDefault: 'Svenska sisu (vaikimisi)',
  ItalianContentDefault: 'Itaalia sisu (vaikimisi)',
  PolishContentDefault: 'Poola sisu (vaikimisi)',
  DanskCategory: 'Danski kategooria',
  GermanCategory: 'Saksa kategooria',
  EnglishCategory: 'Inglise kategooria',
  BritainCategory: 'Suurbritannia kategooria',
  SpanishCategory: 'Hispaania kategooria',
  FrenchCategory: 'Prantsuse kategooria',
  NederlandsCategory: 'Hollandi kategooria',
  NorskCategory: 'Norski kategooria',
  SvenskaCategory: 'Svenska kategooria',
  ItalianCategory: 'Itaalia kategooria',
  PolishCategory: 'Poola kategooria',
  DanskCategoryDefault: 'Danski kategooria (vaikimisi)',
  GermanCategoryDefault: 'Saksa kategooria (vaikimisi)',
  EnglishCategoryDefault: 'Ingliskeelne kategooria (vaikimisi)',
  BritainCategoryDefault: 'Suurbritannia kategooria (vaikimisi)',
  SpanishCategoryDefault: 'Hispaania kategooria (vaikimisi)',
  FrenchCategoryDefault: 'Prantsuse kategooria (vaikimisi)',
  NederlandsCategoryDefault: 'Hollandi kategooria (vaikimisi)',
  NorskCategoryDefault: 'Norski kategooria (vaikimisi)',
  SvenskaCategoryDefault: 'Svenska kategooria (vaikimisi)',
  ItalianCategoryDefault: 'Itaalia kategooria (vaikimisi)',
  PolishCategoryDefault: 'Poola kategooria (vaikimisi)',
  DanskSubcategory: 'Danski alamkategooria',
  GermanSubcategory: 'Saksa alamkategooria',
  EnglishSubcategory: 'Inglise keele alamkategooria',
  BritainSubcategory: 'Suurbritannia alamkategooria',
  SpanishSubcategory: 'Hispaania alamkategooria',
  FrenchSubcategory: 'Prantsuse alamkategooria',
  NederlandsSubcategory: 'Hollandi alamkategooria',
  NorskSubcategory: 'Norski alamkategooria',
  SvenskaSubcategory: 'Svenska alamkategooria',
  ItalianSubcategory: 'Itaalia alamkategooria',
  PolishSubcategory: 'Poola alamkategooria',
  DanskSubcategoryDefault: 'Danski alamkategooria (vaikimisi)',
  GermanSubcategoryDefault: 'Saksa alamkategooria (vaikimisi)',
  EnglishSubcategoryDefault: 'Inglise alamkategooria (vaikimisi)',
  BritainSubcategoryDefault: 'Suurbritannia alamkategooria (vaikimisi)',
  SpanishSubcategoryDefault: 'Hispaania alamkategooria (vaikimisi)',
  FrenchSubcategoryDefault: 'Prantsuse alamkategooria (vaikimisi)',
  NederlandsSubcategoryDefault: 'Nederlandsi alamkategooria (vaikimisi)',
  NorskSubcategoryDefault: 'Norski alamkategooria (vaikimisi)',
  SvenskaSubcategoryDefault: 'Svenska alamkategooria (vaikimisi)',
  ItalianSubcategoryDefault: 'Itaalia alamkategooria (vaikimisi)',
  PolishSubcategoryDefault: 'Poola alamkategooria (vaikimisi)',
  priorSignatures: 'Eelnevad allkirjad',
  damageWaiverSignature: 'Kahjust loobumise allkiri',
  waterReleaseSignature: 'Vee vabastamise allkiri',
  errors,
  themes,
  isPDFRecipientListEnable: 'PDF-i saajate loendi lubamine kliendi allkirjade ekraanil',
  isRejectLoadsEnable: 'Luba Koormuste tagasilükkamine pärast kohalejõudmist',
  rejectLoad_returnedMaterial: 'Tagastatud materjali töövoo nupp',
  rejectLoad_returnedAndFinalize: 'Tagastatud materjal ja töövoo lõpuleviimise nupud',
  driverRejection: 'Keeldu laadimisest',
  submitRejection: 'Esita Keeldu',
  costAndPaymentsSummary: 'Kulude ja maksete kokkuvõte',
  groupCostPriorTotal: 'Telli saatekulu enne kokku',
  subtotal: 'Vahesumma',
  tax: 'Maksud',
  remainingBalance: 'Ülejäänud saldo',
  paymentAmount: 'Makse summa',
  total: 'Kokku',
  paymentMethod: 'Makseviis',
  paymentProducts: 'Tooted',
  unitPrice: 'Ühiku hind',
  amount: 'Summa',
  otherPaymentMethod: 'Muu makseviis',
  method: 'meetod',
  paymentOptions: 'Maksevalikud',
  typeAdditionalInfo: 'Sisestage siia lisateave',
  COD: 'Kohaletoimetamise sularaha',
  AMEX: 'American Express',
  CASH: 'sularaha',
  CHECK: 'Kontrollige',
  'CREDIT CARD': 'Krediitkaart',
  ACCOUNT: 'Ava konto',
  UNKNOWN: 'Tundmatu',
  remainingMaterial: 'Ülejäänud materjal',
  splitLoad: 'Jagatud koormus – mitu',
  isEnablePaymentAndCostWorkflows: 'Lubage maksete ja kulude töövood',
  dotWorkflow: 'Partii üksikasjad',
  inspectorSignature: 'Inspektori allkiri',
  producerSignature: 'Tootja allkiri',
  addedItems: 'Lisatud üksused',
  producerSignatureContact: 'Tootja nimi',
  inspectorSignatureContact: 'Inspektori nimi',
  airTempValue: 'Õhutemperatuur',
  concreteTempValue: 'Betooni temperatuur',
  cylinderNumber: 'Silindri number',
  materialOnTruck: 'Materjalid veokil',
  waterLocation: 'Vee asukoht',
  waterAtPlant: 'Vesi taime juures (gl)',
  waterAtJobsite: 'Vesi töökohal (gl)',
  totalActualWater: 'Tegelik vesi kokku',
  timeDischarged: 'Tühjenemise aeg',
  ingredient: 'Koostis',
  mcFac: 'MCFac',
  absFac: 'ABSFAC',
  od: 'OD',
  abs: 'ABS',
  ssd: 'SSD',
  freeMst: 'Tasuta Mst',
  cydsTarg: 'CYDS TARG',
  target: 'Sihtmärk',
  actual: 'Tegelik',
  freWat: 'Tasuta vesi',
  trim: 'Kärbi',
  batchInformation: 'Partii teave',
  numberOfBatches: 'Partiide arv',
  totalWater: 'Kokku vesi',
  designWater: 'Disain Vesi',
  toAdd: 'Lisamiseks',
  designWC: 'Disain W/C',
  waterCement: 'Vesi / Tsement',
  waterInTruck: 'Vesi veoautos',
  adjustWater: 'Reguleerige vett',
  trimWater: 'Kärbi vett',
  plantWeather: 'Taimede ilm',
  rh: 'RH',
  observationTime: 'Vaatlusaeg',
  address: 'Aadress',
  plant: 'Taim',
  sp: 'S.P. #',
  beginTime: 'Algusaeg',
  mixDesc: 'Sega Kirjeldus',
  qtyOder: 'QTY Tellimus',
  poTag: 'PO #',
  bridge: 'Sild #',
  volume: 'Helitugevus',
  truckTag: 'Veoauto #',
  qtyDelivered: 'Tarnitud kogus',
  qtyOrder: 'QTY Tellimus',
  job: 'Töö #',
  batchRecord: 'Partii kirje',
  mixID: 'Mix ID',
  loads: 'Koormused',
  isDot: 'Kas DOT',
  onlyPrimaryLineItem: 'Ainult esmane reaartikkel',
  tolStatus: 'TOL olek',
  lastUpdate: 'Viimane värskendus',
  driverClickedFinalize: 'Draiver klõpsas Lõpeta',
  autoSubmit: 'Automaatne esitamine',
  noTaxInformationIsAvailable: 'Maksuteave pole saadaval',
  retryPullTaxInformation: 'Värskendage maksuandmeid',
  var: '% Var',
  designQTY: 'Disaini kogus',
  batched: 'Komplekteeritud',
  moisture: 'Niiskus',
  actualWater: 'Tegelik vesi',
  moisturePercent: '% Niiskus',
  freeWater: 'Tasuta vesi',
  reset: 'Lähtesta',
  'at-plant': 'Taime juures',
  'at-job': 'Töö juures',
  viewTickets: 'Vaata pileteid',
  viewSchedule: 'Vaata ajakava',
  viewActiveTicket: 'Vaadake aktiivset piletit',
  dateSelector_last_week: 'Viimased 7 päeva',
  dateSelector_yesterday: 'eile',
  dateSelector_tomorrow: 'Homme',
  dateSelector_today: 'Täna',
  gridHeader_created: 'Loodud',
  gridHeader_customerStatus: 'Kliendi staatus',
  gridHeader_ticketId: 'Pilet',
  gridHeader_vehicle: 'Sõiduk',
  gridFooter_retrieved: 'Välja otsitud',
  gridFooter_loading: 'Laadimine...',
  general: {
    ...CAI_MATERIAL.i18n['en-US'].general,
  },
  component: {
    ...CAI_MATERIAL.i18n['en-US'].component,
  },
  attachments: 'Manused',
  priorOrderCostTotal: 'Eelnev kokku',
  priorOrderPaymentTotal: 'Eelnevad maksed',
  orderShippedCostTotal: 'Tellimus kokku',
  orderShippedBalance: 'Tellimuse saldo',
  ticketSubtotal: 'Pileti vahesumma',
  ticketTax: 'Piletimaks',
  ticketTotal: 'Pilet kokku',
  driverId: 'Juhi ID',
  ticketStatus: 'Pileti olek',
  voided: 'Tühistatud',
  ticketVoidedNotification: 'See pilet on kehtetuks tunnistatud.',
  ticketed: 'Piletiga',
};
